"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var AddCircleOutline_1 = __importDefault(require("@material-ui/icons/AddCircleOutline"));
var ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        modal: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
            width: 400,
            padding: "4 8 6",
        },
        drawer: {
            overflow: "hidden",
            width: 200,
            flexShrink: 0,
        },
        drawerHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        drawerPaper: {
            width: 200,
            position: "static",
        },
    });
});
// returns if array is in an array of arrays
var searchForArray = function (haystack, needle) {
    var _loop_1 = function (element) {
        if (needle.length === element.length && needle.every(function (v) { return element.includes(v); })) {
            return { value: true };
        }
    };
    for (var _i = 0, haystack_1 = haystack; _i < haystack_1.length; _i++) {
        var element = haystack_1[_i];
        var state_1 = _loop_1(element);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return false;
};
// Returns array of method names
var getMethods = function (logs) {
    var methods = [];
    for (var _i = 0, logs_1 = logs; _i < logs_1.length; _i++) {
        var log = logs_1[_i];
        if (!searchForArray(methods, [log.method])) {
            methods.push([log.method]);
        }
    }
    return methods;
};
var MethodList = function (props) {
    /*
      string[][] filters: stores all custom filters created in Modal
      string[] createFilter: stores current custom filter progress before submit
      string[][] methods: stores all methods that have been called
      boolean open: stores boolean value if modal is open or closed
      string[][] allMethods: stores all methods and custom filters
      */
    var _a = react_1.useState([]), filters = _a[0], setFilters = _a[1];
    var _b = react_1.useState([]), createFilter = _b[0], setCreateFilter = _b[1];
    var methods = getMethods(props.logs);
    var _c = react_1.useState(false), modalOpen = _c[0], setModalOpen = _c[1];
    var classes = useStyles();
    var allMethods = __spreadArrays([["all"]], methods, filters);
    var handleChecked = function (event, x) {
        if (x) {
            return setCreateFilter(function (prevCreateFilter) { return __spreadArrays(prevCreateFilter, [event.target.value]); });
        }
        else {
            var array = __spreadArrays(createFilter);
            var index = array.indexOf(event.target.value);
            if (index > -1) {
                array.splice(index, 1);
                return setCreateFilter(__spreadArrays(array));
            }
        }
    };
    var handleSubmit = function (event) {
        setModalOpen(false);
        setCreateFilter([]);
        if (!searchForArray(filters, createFilter)) {
            return setFilters(__spreadArrays(filters, [createFilter]));
        }
    };
    var handleModalOpen = function () {
        setModalOpen(true);
    };
    var handleModalClose = function () {
        setModalOpen(false);
        setCreateFilter([]);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Drawer, { className: classes.drawer, variant: "persistent", anchor: props.alignment, open: props.isDrawerOpen, classes: {
                paper: classes.drawerPaper,
            } },
            react_1.default.createElement("div", { className: classes.drawerHeader },
                react_1.default.createElement(core_1.Typography, { style: { paddingLeft: "15px", userSelect: "none" }, color: "primary" }, "Filter"),
                react_1.default.createElement(core_1.IconButton, { onClick: props.closeDrawer }, props.alignment === "left" ? react_1.default.createElement(ChevronLeft_1.default, null) : react_1.default.createElement(ChevronRight_1.default, null))),
            react_1.default.createElement(core_1.Divider, null),
            react_1.default.createElement(core_1.List, null,
                allMethods.map(function (filter) { return (react_1.default.createElement(core_1.ListItem, { button: true, key: filter.join(" "), onClick: function () { return props.select(filter); }, selected: props.active.join("") === filter.join("") },
                    react_1.default.createElement(core_1.ListItemText, null, filter.join(", ")))); }),
                react_1.default.createElement("div", { style: methods.length > 2 ? {} : { display: "none" } },
                    react_1.default.createElement(core_1.ListItem, { button: true, onClick: handleModalOpen },
                        react_1.default.createElement(core_1.ListItemIcon, null, react_1.default.createElement(AddCircleOutline_1.default, null)),
                        react_1.default.createElement(core_1.ListItemText, null, "add new filter"))))),
        react_1.default.createElement(core_1.Modal, { open: modalOpen, onClose: handleModalClose, "aria-labelledby": "modal-label" },
            react_1.default.createElement(core_1.Paper, { className: classes.modal },
                react_1.default.createElement(core_1.FormControl, null,
                    react_1.default.createElement("h2", { id: "modal-label" }, "Select methods you wish to filter by"),
                    react_1.default.createElement(core_1.FormGroup, null, methods.map(function (method) { return (react_1.default.createElement(core_1.FormControlLabel, { control: react_1.default.createElement(core_1.Checkbox, { value: method, key: method.toString(), onChange: handleChecked, checked: createFilter.includes(method[0]) }), label: method.join(" ") })); })),
                    react_1.default.createElement(core_1.Button, { variant: "contained", onClick: handleSubmit }, "Submit"))))));
};
exports.default = MethodList;
